/**
 * Portal-local CSRF cookie reader.
 *
 * The white-label portal (*.portal.ddmarc.com) and the dashboard
 * (app.ddmarc.com) share the parent ".ddmarc.com" cookie domain in prod. To
 * keep the two sessions fully independent, the portal has its own CSRF cookie
 * name — `portal_csrf_token` — set by the backend on portal login/refresh
 * (set_portal_auth_cookies). This mirrors
 * packages/shared/src/auth/auth.ts:getCSRFToken but reads the portal cookie so
 * a dashboard session's csrf_token can never satisfy the portal's guard.
 */
export function getPortalCSRFToken(): string | null {
  // Anchored to a cookie boundary for the same reason as the dashboard reader:
  // a name that merely ENDS in this one must not be picked up.
  const match = document.cookie.match(/(?:^|;\s*)portal_csrf_token=([^;]+)/);
  return match?.[1] ?? null;
}
